import { useReducer, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import DeliveryClient from "../../clients/DeliveryClient";
import { taskReducer } from "../reducers/taskReducer";
import {
  FETCH_TASKS,
  FILTER_TASKS,
  SET_TASKS,
} from "../constants/PreDeliveryTaskConstants";

const initialState = {
  tasks: {},
  filteredTasks: [],
  loading: false,
  error: null,
};

const usePreDeliveryTasks = (
  initialVehicleType,
  dealerPaCode,
  dealerCommonId
) => {
  const [state, dispatch] = useReducer(taskReducer, initialState);

  const { isFetching, error } = useQuery({
    queryKey: ["preDeliveryTasks", dealerPaCode, dealerCommonId],
    queryFn: async () => {
      const response = await DeliveryClient.getPreDeliveryTasks(
        dealerPaCode,
        dealerCommonId
      );

      return response.data;
    },
    enabled: Boolean(dealerPaCode),
    retry: 1,
    onSuccess: (data) => {
      dispatch({
        type: SET_TASKS,
        payload: { data, vehicleType: initialVehicleType },
      });
    },
    onError: (queryError) => {
      dispatch({
        type: FETCH_TASKS,
        payload: {
          error: queryError.message,
        },
      });
    },
  });

  useEffect(() => {
    if (isFetching) {
      dispatch({ type: FETCH_TASKS });
    }

    if (error) {
      dispatch({
        type: FETCH_TASKS,
        payload: {
          error: error.message,
        },
      });
    }
  }, [isFetching, error]);

  const filterTasks = (vehicleType) => {
    const filtered = state.tasks[vehicleType] || [];

    dispatch({
      type: FILTER_TASKS,
      payload: filtered,
    });
  };

  const updateTasks = (data, currentVehicleType) => {
    dispatch({
      type: SET_TASKS,
      payload: {
        data,
        vehicleType: currentVehicleType,
      },
    });
  };

  return {
    tasks: state.tasks,
    filteredTasks: state.filteredTasks,
    loading: state.loading,
    error: state.error,
    filterTasks,
    updateTasks,
  };
};

export default usePreDeliveryTasks;
